import {
  type CompliancePolicy,
  type CompliancePolicyUpdateInput,
  type CompliancePolicyUpdateSuccess,
  toResponseError,
} from '@terros/common'
import { mutationUpdate, type UpdateHookResponse } from '../../hooks'
import { useTantalimMutation } from '../../mutation'
import { useCompliancePolicyCache } from './cache'

export function useUpdateCompliancePolicy(): UpdateHookResponse<CompliancePolicyUpdateInput, CompliancePolicy> {
  const cache = useCompliancePolicyCache()

  const mutation = useTantalimMutation<CompliancePolicyUpdateInput, CompliancePolicyUpdateSuccess>({
    url: '/compliance/policy/update',
  })

  async function update(updatedPolicy: CompliancePolicyUpdateInput): Promise<CompliancePolicy> {
    try {
      const { policy } = await mutation.mutateAsync(updatedPolicy)
      cache.setItem(policy)
      return policy
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
